import { css } from '@emotion/css';
import { Slider,Slide } from 'Shared/frontend/Slider';
import { theme } from 'Shared/frontend/SettingsProvider';
import { amount } from 'Shared/frontend/widgets/Amount';
import { Component } from 'Shared/frontend/widgets/Component';
import { lookupRatio } from 'Shared/frontend/widgets/HeightUtils';
import { ChildKeyContext } from 'Shared/frontend/widgets/StylesProvider';
import { For, Show } from 'solid-js';

//XXX cf nesting in a set height (eg overlay foreground) ==> can use 100%
//XXX cf allow children to size things ==> use undefined.

/*
	The are three options when regarding heights:
	1. Set it in the Slider - in which case the top element has the size on it, and the children are set to 100%.
	2. Set the height to 100% and allow the parent to set it. Much the same as option 1. Both are 'top down' (at least within this component).
	3. We size it to the maximum child height - in which case the top node and intermediate nodes need the height to be 'unset' of fit-content.
*/

interface ISlides {
	slides;
	height;
}

export function Slides(P:ISlides)
{
	const slideStyle = (height) => css({
		backgroundColor: theme().widgets.slideshow.backgroundColour,

		...(height.ratio ? {aspectRatio: lookupRatio(height)} : {}),
		/* Helps in Chrome */
		...(height.ratio ? {height: '100%'} : {}),

		...(height.height ? {minHeight: amount(height.height)} : {}),
		...(height.height ? {maxHeight: amount(height.height)} : {}),
	});


	/* Think empty sliders lack 'P.slides' and this causes initialisation problems without the guard. */
	return (
		<Show when={P.slides}>		
			<Slider options={{}} inheritHeight={P.height.parent} class={css(P.styling.css ?? {})}>
				<For each={P.slides}>{(item,index) =>
					<ChildKeyContext.Provider value={index}>
						<Slide class={slideStyle(P.height)}>
							<Component {...item} />
						</Slide>
					</ChildKeyContext.Provider>
				}</For>
			</Slider>
		</Show>
	);
}

